<div class="agpr-quotaUsageDashboard">
    <div *ngIf="showHeader" class="agpr-quotaUsageDashboard-header">
        <div class="agpr-quotaUsageDashboard-headerTitle">
            <agpr-button [id]="'agpr-quotaUsageDashboard' + '_toggleButton_left'"
                class="agpr-quotaUsageDashboard-headerTitle-toggleButton" [style]="buttonTypes.icon"
                [icon]="'fa-solid ' + (expanded ? 'fa-angle-right' : 'fa-angle-left')"
                tooltip="Social.intelligence.themeManagement.quotaUsagePanel.toggleButton.tooltip"
                (click)="toggleQuotaUsageWidget()"></agpr-button>
            <h2 class="agpr-quotaUsageDashboard-headerTitle-label">
                {{ headerLabelKey | localize }}
            </h2>
        </div>
        <agpr-button *ngIf="expanded" [id]="'agpr-quotaUsageDashboard' + '_toggleButton_right'"
            class="agpr-quotaUsagePanel-pinToggle" [style]="buttonTypes.icon"
            [icon]="isPinned ? 'fa-solid fa-thumbtack' : 'fa-solid fa-thumbtack-slash'"
            tooltip="Social.intelligence.themeManagement.quotaUsagePanel.pinButton.tooltip"
            srLabel="Social.intelligence.themeManagement.quotaUsagePanel.pinButton.tooltip"
            (click)="themeService.toggleQuotaVisibility(!isPinned)"></agpr-button>
    </div>
    <div *ngIf="showBanner" class="agpr-quotaUsageDashboard-toolbar">
        <ng-container *ngTemplateOutlet="dateRange"></ng-container>
        <span *ngIf="expanded" class="agpr-quotaUsageDashboard-toolbar-purchaseBanner"
            [innerHTML]="'Social.intelligence.themeManagement.quotaUsagePanel.perchaseBanner' | localize"></span>
    </div>
    <div class="agpr-quotaUsageDashboard-contentWrapper">
        @if (expanded) {
            <div class="agpr-quotaUsageDashboard-feedback">
                <agpr-message [severity]='messageSeverityEnum.info' [bottomMargin]="false" [autoFit]="true" [closeable]="false">
                    <p>{{ 'Social.intelligence.themeManagement.quotaUsagePanel.feedback.aboutPeriod' | localize }}</p>
                    <p>{{ 'Social.intelligence.themeManagement.quotaUsagePanel.feedback.aboutDate' | localize }}</p>
                </agpr-message>
            </div>
        }

        <div class="agpr-quotaUsageDashboard-content">
            <div class="agpr-quotaUsageDashboard-sidePanel"
                [agprLoading]="quotaLoading"
                [ngClass]="{'agpr-quotaUsageDashboard-sidePanel--expand': expanded}">

                <div *ngIf="!showBanner" class="agpr-quotaUsageDashboard-sidePanelDatequery">
                    <ng-container *ngTemplateOutlet="dateRange"></ng-container>
                </div>
                <agpr-scroll-panel>
                    <div class="agpr-quotaUsageDashboard-sidePanelChart">
                        <agpr-chart [chart]="dailyAverageUsageChart"></agpr-chart>
                    </div>
                    <div class="agpr-quotaUsageDashboard-statField">
                        <label class="agpr-quotaUsageDashboard-statFieldLabel">{{
                            'Social.intelligence.themeManagement.quotaUsagePanel.totalQuota' | localize }}</label>
                        <span class="agpr-quotaUsageDashboard-statFieldCount">{{ totalQuota }}</span>
                    </div>
                    <div class="agpr-quotaUsageDashboard-statField">
                        <label class="agpr-quotaUsageDashboard-statFieldLabel">{{
                            'Social.intelligence.themeManagement.quotaUsagePanel.totalQuotaUsed' | localize }}</label>
                        <span class="agpr-quotaUsageDashboard-statFieldCount">{{ totalQuotaUsed }}</span>
                    </div>
                    <div class="agpr-quotaUsageDashboard-statField">
                        <label class="agpr-quotaUsageDashboard-statFieldLabel">{{
                            'Social.intelligence.themeManagement.quotaUsagePanel.totalQuotaUsedPercentage' | localize
                            }}</label>
                        <span class="agpr-quotaUsageDashboard-statFieldCount">{{ totalQuotaUsedPercentage }}</span>
                    </div>
                    <div class="agpr-quotaUsageDashboard-statField">
                        <label class="agpr-quotaUsageDashboard-statFieldLabel">{{
                            'Social.intelligence.themeManagement.quotaUsagePanel.daysRemaining' | localize }}</label>
                        <span class="agpr-quotaUsageDashboard-statFieldCount">{{ daysRemaining }}</span>
                    </div>
                    <div class="agpr-quotaUsageDashboard-statField">
                        <label class="agpr-quotaUsageDashboard-statFieldLabel">{{
                            'Social.intelligence.themeManagement.quotaUsagePanel.quotaResetDate' | localize }}</label>
                        <span class="agpr-quotaUsageDashboard-statFieldDate">{{ quotaResetDate }}</span>
                    </div>
                </agpr-scroll-panel>
            </div>
            <div *ngIf="expanded" class="agpr-quotaUsageDashboard-separator"></div>
            <div *ngIf="expanded" class="agpr-quotaUsageDashboard-usageInfo">
                <div class="agpr-quotaUsageDashboard-usageInfoWrapper"  [agprLoading]="socailThemedIdsLoading">
                    <div class="agpr-quotaUsageDashboard-usageInfo-header agpr-quotaUsageDashboard-usageInfo-grid">
                        <span>{{'Social.intelligence.themeManagement.quotaBreakdownPanel.consumer' | localize}}</span>
                        <span>{{'Social.intelligence.themeManagement.quotaBreakdownPanel.usage' | localize }}</span>
                        <span>{{'Social.intelligence.themeManagement.quotaBreakdownPanel.type' | localize }}</span>

                    </div>
                    <div class="agpr-quotaUsageDashboard-usageInfo-listContent">
                        <agpr-scroll-panel>
                            <ul class="agpr-quotaUsageDashboard-usageInfo-listContent-wrapper">
                                @if (filteredQuotaDetails.length === 0) {
                                    <li class="agpr-quotaUsageDashboard-usageInfo-empty">
                                        {{'Social.intelligence.themeManagement.quotaBreakdownPanel.noData' | localize }}
                                    </li>
                                }
                                @for (quotaDetail of filteredQuotaDetails; track quotaDetail.item.subId; let i = $index) {
                                    <li
                                        class="agpr-quotaUsageDashboard-usageInfo-item"
                                        [@containerState]="quotaDetail.collased ? 'collapsed' : 'expanded'"
                                    >
                                        <div class="agpr-quotaUsageDashboard-usageInfo-grid"
                                            [ngClass]="{'agpr-quotaUsageDashboard-usageInfo-parent': quotaDetail.hasBackFills}"
                                            (click)="quotaDetail.collased = !quotaDetail.collased">
                                            <span class="agpr-quotaUsageDashboard-usageInfo-item-title">
                                                {{quotaDetail.item.subLabel}}
                                            </span>
                                            <span>
                                                    {{quotaDetail.totalCount}}
                                            </span>

                                            <div class="agpr-quotaUsageDashboard-usageInfo-buttonsWrapper">
                                                <span>{{quotaDetail.item.socialType}}</span>

                                                <div class="agpr-quotaUsageDashboard-usageInfo-buttons" >
                                                    @let showAllSpiltButtons = !quotaDetail.item.isSocial || socialMediaMap[quotaDetail.item?.subId];
                                                    <agpr-split-button class="agpr-quotaUsageDashboard-usageInfo-splitButton" id="agpr-quotaUsageDashboard.saveTopicButton"
                                                        icon='fa-light fa-ellipsis-vertical'
                                                        [showTriggerIcon]="false"
                                                        [data]="quotaDetail.item"
                                                        [options]="!!showAllSpiltButtons ? allActions : [allActions[0]]"
                                                        [style]="buttonTypes.icon"
                                                        [panelPositionY]="filteredQuotaDetails.length > 3 && i >= filteredQuotaDetails.length - 2 ? 'top' : 'bottom'"
                                                        panelPositionX="right"></agpr-split-button>
                                                    <agpr-button id="'agpr-quotaUsageDashboard-usageInfo-toggleButton"
                                                        [ngClass]="{'agpr-quotaUsageDashboard-usageInfo-toggleButton--hidden': !quotaDetail.hasBackFills}"
                                                        [style]="buttonTypes.icon"
                                                        [icon]="'fa-solid agpr-expandToggle ' + (quotaDetail.collased ?'fa-angle-down' :'fa-angle-up')"
                                                        tooltip='Social.intelligence.themeManagement.quotaBreakdownPanel.button.expand'
                                                        tooltipPosition="left" (click)="quotaDetail.collased = !quotaDetail.collased">
                                                    </agpr-button>
                                                </div>

                                            </div>
                                        </div>
                                        @if (quotaDetail.hasBackFills) {
                                            <div [hidden]="quotaDetail.collased">
                                                <div class="agpr-quotaUsageDashboard-usageInfo-grid agpr-quotaUsageDashboard-usageInfo-child">
                                                    <span>{{'Social.intelligence.themeManagement.quotaBreakdownPanel.usage.standard' |
                                                        localize }}</span>
                                                    <span>{{quotaDetail.item.quotaHistory.liveCount}}</span>
                                                    <span></span>
                                                </div>
                                                @for (backfill of quotaDetail.item.backfills; track backfill.id; let i = $index) {
                                                    <div class="agpr-quotaUsageDashboard-usageInfo-grid agpr-quotaUsageDashboard-usageInfo-child">
                                                        <span> {{'Social.intelligence.themeManagement.quotaBreakdownPanel.usage.replay' |
                                                            localize }}{{backfill.backfillBeginDate}}</span>
                                                        <span>{{backfill.numberOfMentionsCollected}}</span>
                                                        <span></span>
                                                    </div>
                                                }
                                            </div>
                                        }
                                    </li>
                                }
                            </ul>
                        </agpr-scroll-panel>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #dateRange>
    <agpr-date-query-popup
        id="quotaSearchDatequery"
        [useDateSearchRangeSelection]="false"
        [options]="quotaDateQueryInputTopicOptions"
        [(ngModel)]="dateFilterSelected"
        (ngModelChange)="calculateAccountStats()">
    </agpr-date-query-popup>
</ng-template>
